import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authMe } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // null = unknown/checking, false = anon, obj = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("es_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const me = await authMe();
      setUser(me);
    } catch {
      localStorage.removeItem("es_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await authLogin(email, password);
    localStorage.setItem("es_token", res.access_token);
    await refresh();
    return res;
  };

  const logout = () => {
    localStorage.removeItem("es_token");
    setUser(false);
  };

  const isSysadmin = user && user.role === "sysadmin";
  const isTenantAdmin = user && user.role === "tenant_admin";
  const canManageTeam = isSysadmin || isTenantAdmin;

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh, isSysadmin, isTenantAdmin, canManageTeam }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
